module.exports = __webpack_public_path__ + "img/title-03.759d2a53.png";